import { IFeatureFlag, FeatureFlagId } from 'types/featureflags';
import { EnvName } from 'utils/api';

const { PRODUCTION, SANDBOX, LOCAL, PREVIEW, TEST } = EnvName;

export const FEATURE_FLAGS_DEFAULTS: Record<FeatureFlagId, IFeatureFlag> = {
	[FeatureFlagId.TEST_FF]: {
		id: FeatureFlagId.TEST_FF,
		env: {
			[PRODUCTION]: true,
			[SANDBOX]: true,
			[PREVIEW]: true,
			[LOCAL]: true,
			[TEST]: true
		}
	},
	[FeatureFlagId.FGA_MAPPINGS]: {
		id: FeatureFlagId.FGA_MAPPINGS,
		env: {
			[PRODUCTION]: true,
			[SANDBOX]: true, // feature enable with url param: `?feature:fgaMappings=true`
			[PREVIEW]: true,
			[LOCAL]: true,
			[TEST]: true
		}
	},
	[FeatureFlagId.SSO_OIDC_GROUP_MAPPING]: {
		id: FeatureFlagId.SSO_OIDC_GROUP_MAPPING,
		env: {
			[PRODUCTION]: true,
			[SANDBOX]: true, // feature enable with url param: `?feature:SSO_OIDC_GROUP_MAPPING=true`
			[PREVIEW]: true,
			[LOCAL]: true,
			[TEST]: true
		}
	},
	[FeatureFlagId.PRESERVE_QUERY_PARAMS]: {
		id: FeatureFlagId.PRESERVE_QUERY_PARAMS,
		env: {
			[PRODUCTION]: false,
			[SANDBOX]: false, // feature enable with url param: `?feature:preserveQueryParams=true`
			[PREVIEW]: false,
			[LOCAL]: false,
			[TEST]: false
		}
	},
	[FeatureFlagId.JIT_CARD]: {
		id: FeatureFlagId.JIT_CARD,
		env: {
			[PRODUCTION]: true,
			[SANDBOX]: true, // feature enable with url param: `?feature:ssoSuiteJitCard=true`
			[PREVIEW]: true,
			[LOCAL]: true,
			[TEST]: true
		}
	},
	[FeatureFlagId.SHOW_SAVE_WHEN_UNTESTED]: {
		id: FeatureFlagId.SHOW_SAVE_WHEN_UNTESTED,
		env: {
			[PRODUCTION]: true,
			[SANDBOX]: true,
			[PREVIEW]: true,
			[LOCAL]: true,
			[TEST]: true
		}
	},
	[FeatureFlagId.SKIP_SAML_CERT_VALIDATION]: {
		id: FeatureFlagId.SKIP_SAML_CERT_VALIDATION,
		env: {
			[PRODUCTION]: false,
			[SANDBOX]: false, // feature enable with url param: `?feature:skipSamlCertValidation=true`
			[PREVIEW]: false,
			[LOCAL]: false,
			[TEST]: false
		}
	},
	[FeatureFlagId.HIDE_SSO_DELETE]: {
		id: FeatureFlagId.HIDE_SSO_DELETE,
		env: {
			[PRODUCTION]: false,
			[SANDBOX]: false, // feature enable with url param: `?feature:ssoSuiteHideSsoDelete=true`
			[PREVIEW]: false,
			[LOCAL]: false,
			[TEST]: false
		}
	},
	[FeatureFlagId.SSO_SUITE_AUDIT]: {
		id: FeatureFlagId.SSO_SUITE_AUDIT,
		env: {
			[PRODUCTION]: true,
			[SANDBOX]: true,
			[PREVIEW]: true,
			[LOCAL]: true,
			[TEST]: true
		}
	}
};

(window as any).FEATURE_FLAGS = Object.values(FEATURE_FLAGS_DEFAULTS).map(
	(flag) => ({
		isHidden: flag.env?.[PRODUCTION] === false && flag.env?.[SANDBOX] === false,
		queryParam: `?feature:${flag.id}=true`
	})
);
